import { defineMessages } from "react-intl";

export default defineMessages({
  serviceFeeFormulaShort: {
    id: "serviceFeeFormulaSummary.serviceFeeFormulaShort",
    defaultMessage: "Service fee",
  },
  viewPriceEstimate: {
    id: "serviceFeeFormulaSummary.viewPriceEstimate",
    defaultMessage: "View price estimate",
  },
  yourFormula: {
    id: "serviceFeeFormulaSummary.yourFormula",
    defaultMessage: "Your formula",
  },
  change: {
    id: "serviceFeeFormulaSummary.change",
    defaultMessage: "Change",
  },
});
